import Button from "./prop/Button"

export default function Contact() {

    return (
        <section className="contact-container" id="contact">
            <img src="./img/logo/logo-maestrom.png" alt="Logo de Maestrom" className="logo" />
            <div className="btn-container">
                <Button label='06 76 22 64 73' color='red' />
                <Button label='contact@maestrom-digital.fr' color='white' outline />
            </div>
            <p>
                Depuis 2019, Maestrom s’engage à accompagner tous types d’entreprises, de l’entrepreneur individuel à la PME en passant par la Start-up afin de répondre à leurs besoins digitales.
            </p>
        </section>
    )
}